import type { TareData } from './TareData';

// Store a cache of tare data, so that we can access it synchronously
let tareDataCache: TareData | null = null;

export function getCachedTareData(): TareData | null {
    return tareDataCache;
}

export function setCachedTareData(data: TareData): void {
    tareDataCache = data;
}
